module.exports = __webpack_public_path__ + "images/video-animation-1-5b529f8f82a3db92caa6d56c1ad40c76.jpg";